import createHttp from './request'

/**
 * @typedef {Object} CertUserListParams
 * @property {Array<{fieldName: string, asc?: boolean, dateAggregateBy?: string}>} [orderParam] - 排序参数
 * @property {*} [key] - 其他参数
 */

/**
 * @typedef {Object} CertUser
 * @property {number} id - 证书ID
 * @property {string} certName - 证书名称
 * @property {number} certType - 证书类型
 * @property {string} issuedTime - 颁发时间
 * @property {string} expireTime - 过期时间
 * @property {number} status - 状态
 * @property {string} [templateUrl] - 模板URL
 */

/**
 * @typedef {Object} CertUserListResponse
 * @property {CertUser[]} dataList - 证书列表
 */

/**
 * 证书管理
 * @param {CertUserListParams} data
 * @returns {Promise<CertUserListResponse>}
 */
export function certUserList(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/certUser/student/list',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 获取用户信息
 * @param data
 * @returns {*}
 */
export function getUserSelfInfo() {
  const http = createHttp()
  return http({
    url: `/admin/upms/students/viewSelf`,
    method: 'get',
    requireAuth: true,
  })
}

/**
 * 获取培养计划全流程数据（学员信息、报名录取、现场确认、缴费阶段等）
 * @returns {*}
 */
export function getTrainingPlanSelf() {
  const http = createHttp()
  return http({
    url: '/admin/upms/enrollmentApplications/viewSelf',
    method: 'post',
    requireAuth: true,
  })
}

/**
 * 获取用户信息
 * @param data
 * @returns {*}
 */
export function getUserInfo(userId) {
  const http = createHttp()
  return http({
    url: `/admin/upms/students/view`,
    method: 'get',
    requireAuth: true,
    params: {
      userId
    }
  })
}
/**
 * 获取证书编码
 * @param userId
 * @returns {*}
 */
export function getCertCode(data) {
  const http = createHttp()
  return http({
    url: `/admin/upms/numberRule/getSeq`,
    method: 'post',
    requireAuth: true,
    data
  })
}

//获取证书详情
export function getCertInfo(data) {
  const http = createHttp()
  return http({
    url: `/admin/upms/certUser/view`,
    method: 'get',
    requireAuth: true,
    params: data
  })
}

//获取图片资源链接
export function getImageBase64(data) {
  const http = createHttp()
  return http({
    url: `/admin/upms/certUser/toBase64`,
    method: 'post',
    requireAuth: true,
    params: data
  })
}

/**
 * 修改用户头像
 * @param {FormData} formData - 包含uploadFile字段的FormData对象
 * @returns {Promise}
 */
export function changeHeadImage(formData) {
  const http = createHttp()
  return http({
    url: '/admin/upms/students/changeHeadImage',
    method: 'post',
    requireAuth: true,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 提交实名认证
 * @param {Object} data - 包含真实姓名、证件类型、证件号码
 * @returns {Promise}
 */
export function submitRealNameAuth(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/students/realNameAuth',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 查询实名认证状态
 * @returns {Promise}
 */
export function getRealNameAuthStatus() {
  const http = createHttp()
  return http({
    url: '/admin/upms/students/realNameAuth/status',
    method: 'get',
    requireAuth: true
  })
}

/**
 * 更新学生信息（邮箱、通讯地址和邮寄地址）
 * @param {Object} data - 包含studentsUpdateDto对象
 * @returns {Promise}
 */
export function updateStudentInfo(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/students/simple/update',
    method: 'post',
    requireAuth: true,
    data
  })
}

//身份证识别
export function identifyCard(formData) {
  const http = createHttp()
  return http({
    url: `/admin/upms/enrollmentApplications/identify/card`,
    method: 'post',
    requireAuth: true,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

//实名认证
export function userRealNameAuthAdd(data) {
  const http = createHttp()
  return http({
    url: `/admin/upms/userRealNameAuth/add`,
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 缴费订单列表
 * @param {Object} data
 * @returns {Promise}
 */
export function paymentsList(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/payments/listOfStudent',
    method: 'post',
    requireAuth: true,
    data
  })
}

//实名认证详情
export function userRealNameAuthView() {
  const http = createHttp()
  return http({
    url: `/admin/upms/userRealNameAuth/view`,
    method: 'get',
    requireAuth: true
  })
}

/**
 * 获取学生学习概览
 * @returns {Promise<any>}
 */
export function getStudentOverview() {
  const http = createHttp()
  return http({
    url: '/admin/upms/students/overview',
    method: 'post',
    requireAuth: true
  })
}

/**
 * 获取学员画像
 * @returns {Promise<any>}
 */
export function getUserPortrait() {
  const http = createHttp()
  return http({
    url: '/admin/upms/statistics/userPortrait',
    method: 'post',
    requireAuth: true
  })
}

/**
 * 平台服务费
 * @param {Object} data
 * @returns {Promise}
 */
export function paymentsServicePr(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/payments/viewServicePr',
    method: 'post',
    requireAuth: true,
    data
  })
}
/**
 * 获取学籍异动列表
 * @returns {Promise<any>}
 */
export function getStudentChangeList(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/studentChange/list',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 获取当前学员学籍异动列表（学员端自助）
 * @param {Object} data
 * @returns {Promise<any>}
 */
export function getStudentChangeListSelf(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/studentChange/listSelft',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 学费
 * @param {Object} data
 * @returns {Promise}
 */
export function paymentsPr(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/payments/viewPr',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 新增学籍异动列表
 * @returns {Promise<any>}
 */
export function studentChangeAdd(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/studentChange/add',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 根据订单号获取订单详情 （轮询接口）
 * @param {string|number} orderId - 订单ID
 * @returns {Promise}
 */
export function getOrderStatus(orderId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/payments/getOrderStatus',
    method: 'get',
    requireAuth: true,
    params: {
      orderId
    }
  })
}

/**
 * 陕中医缴费中心获取url
 * @returns {Promise<any>}
 */
export function paymentsGetUrl(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/payments/getUrl',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 陕中医缴费接口
 * @returns {Promise<any>}
 */
export function paymentsGetTuition(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/payments/getTuition',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 根据用户ID获取档案信息
 * @param {string|number} userId - 用户ID
 * @returns {Promise<any>}
 */
export function getStudentsArchiveByUserId(userId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/studentsArchive/viewByUserId',
    method: 'get',
    requireAuth: true,
    params: {
      userId
    }
  })
}

/**
 * 学籍证明预览（报名管理 + 现场确认数据源）
 * @returns {Promise<{ templateName: string, filledBody: string, available: boolean }>}
 */
export function studentStatusCertIssuePreview() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/studentStatusCertIssue/preview',
    method: 'post',
    requireAuth: true,
  })
}

/**
 * 导入学籍证明 PDF（报名管理 + 现场确认数据源）
 * @returns {Promise<Blob>}
 */
export function studentStatusCertIssueExportPdf() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/studentStatusCertIssue/exportPdf',
    method: 'get',
    requireAuth: true,
    responseType: 'blob',
  })
}

/**
 * 在读证明申请：当前学员申请态
 */
export function studentStatusCertApplyMyLatest() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/studentStatusCertApply/myLatest',
    method: 'get',
    requireAuth: true,
  })
}

/**
 * 在读证明申请：当前学员申请记录列表
 */
export function studentStatusCertApplyMyList() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/studentStatusCertApply/myList',
    method: 'get',
    requireAuth: true,
  })
}

/**
 * 在读证明申请：提交（理由 + 签名图 URL）
 */
export function studentStatusCertApplySubmit(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/studentStatusCertApply/submit',
    method: 'post',
    requireAuth: true,
    data: { studentStatusCertApplicationDto: data },
  })
}

/**
 * 学员端：报名资料补全详情（缺项清单）
 */
export function enrollmentProfileIncomplete() {
  const http = createHttp()
  return http({
    url: '/admin/upms/enrollmentApplications/student/profile/incomplete',
    method: 'post',
    requireAuth: true,
  })
}

/**
 * 学员端：提交报名资料补全
 * @param {Object} data - { applicationId, fieldValues, attachList }
 */
export function enrollmentProfileComplete(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/enrollmentApplications/student/profile/complete',
    method: 'post',
    requireAuth: true,
    data,
  })
}

/**
 * 报名附件上传（资料补全）
 * @param {FormData} formData - tenantId + uploadFile
 */
export function uploadEnrollmentAttach(formData) {
  const http = createHttp()
  return http({
    url: '/admin/upms/enrollmentAttach/upload',
    method: 'post',
    requireAuth: true,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 通用文件上传（签名图等）
 */
export function uploadCommonFile(formData) {
  const http = createHttp()
  return http({
    url: '/admin/commonext/util/upload',
    method: 'post',
    requireAuth: true,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 成绩归档证明预览
 * @returns {Promise<{ templateName: string, filledBody: string, available: boolean }>}
 */
export function scoreArchiveCertIssuePreview() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/scoreArchiveCertIssue/preview',
    method: 'post',
    requireAuth: true,
  })
}

/**
 * 导出成绩归档证明 PDF
 * @returns {Promise<Blob>}
 */
export function scoreArchiveCertIssueExportPdf() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/scoreArchiveCertIssue/exportPdf',
    method: 'get',
    requireAuth: true,
    responseType: 'blob',
  })
}

/**
 * 学员查看自己的申请状态
 * @returns {Promise<any>}
 */
export function getSelfApplication(userId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/sysApplication/viewSelf',
    method: 'get',
    params: { userId },
    requireAuth: true
  })
}

/**
 * 学员提交信息确认或修改申请
 * @param {Object} data 申请数据
 * @returns {Promise<any>}
 */
export function submitSelfApplication(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/sysApplication/submitSelf',
    method: 'post',
    data: { sysApplicationDto: data },
    requireAuth: true
  })
}

/**
 * 学员查看自己的通知列表（分页 + 时间筛选）
 * @param {object} params 查询参数
 * @param {number} [params.pageNum=1] 页码
 * @param {number} [params.pageSize=5] 每页条数
 * @param {string} [params.sendStartTime] 发送起始时间 yyyy-MM-dd
 * @param {string} [params.sendEndTime] 发送截止时间 yyyy-MM-dd
 * @param {number} [params.readStatus] 阅读状态（0:未读 1:已读），不传则查全部
 * @returns {Promise<any>}
 */
export function getSelfNotificationList(params = {}) {
  const http = createHttp()
  return http({
    url: '/admin/upms/smsStudentDetail/listSelf',
    method: 'get',
    params,
    requireAuth: true
  })
}

/**
 * 学员标记通知为已读
 * @param {string|number} detailId 通知ID
 * @returns {Promise<any>}
 */
export function markNotificationRead(detailId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/smsStudentDetail/markRead',
    method: 'post',
    params: { detailId },
    requireAuth: true
  })
}

/**
 * 学员标记所有通知为已读
 * @returns {Promise<any>}
 */
export function markAllNotificationRead() {
  const http = createHttp()
  return http({
    url: '/admin/upms/smsStudentDetail/markAllRead',
    method: 'post',
    requireAuth: true
  })
}

/**
 * 学员获取自己的通知统计（总数、未读数、今日数、重要数）
 * @returns {Promise<any>}
 */
export function getSelfNotificationStats() {
  const http = createHttp()
  return http({
    url: '/admin/upms/smsStudentDetail/statsSelf',
    method: 'get',
    requireAuth: true
  })
}

/**
 * 申请开具发票
 * @param {Object} data 发票申请信息
 * @returns {Promise<any>}
 */
export function invoiceApply(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/invoiceRecord/add',
    method: 'post',
    requireAuth: true,
    data
  })
}

/**
 * 查询我的发票记录
 * @param {Object} data 查询参数
 * @returns {Promise<any>}
 */
export function invoiceList(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/invoiceRecord/list',
    method: 'post',
    requireAuth: true,
    data
  })
}
